module.exports = __webpack_public_path__ + "img/03.147273b5.png";